import { render, staticRenderFns } from "./goodTableCustomPager.vue?vue&type=template&id=e09ce578&"
import script from "./goodTableCustomPager.vue?vue&type=script&lang=js&"
export * from "./goodTableCustomPager.vue?vue&type=script&lang=js&"
import style0 from "./goodTableCustomPager.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports